const fmt = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    maximumFractionDigits: 2,
});
const fmt0 = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    maximumFractionDigits: 0,
});
export function formatCents(cents, opts) {
    const dollars = cents / 100;
    return opts?.round ? fmt0.format(dollars) : fmt.format(dollars);
}
export function cn(...classes) {
    return classes.filter(Boolean).join(" ");
}
